import { useI18n } from '../i18n/I18nProvider';

export function StepProgress({ current }: { current: number }) {
  const { t } = useI18n();
  const steps = [t('progress.tattoo'), t('progress.adjust'), t('progress.result')];
  return (
    <div className="step-progress" aria-label={t('progress.label', { step: current + 1, name: steps[current] })}>
      <span>{t('progress.step', { step: current + 1 })}</span>
      <ol>{steps.map((step, index) => (
        <li key={step} className={index < current ? 'is-complete' : index === current ? 'is-current' : ''}><span className="visually-hidden">{step}</span></li>
      ))}</ol>
    </div>
  );
}
